import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatToggle = createCustomElementWrapper('kat-toggle', 'KatToggle', {
    'textChecked': 'text-checked',
    'textUnchecked': 'text-unchecked',
    'uniqueId': 'unique-id',
}, {
    'onChange': 'change',
}, [
    'unchecked',
]);
